import { Link } from 'react-router-dom';
import stravaImg from '../assets/strava_logo_nav.png';
import styles from '../pages/appbar.module.css';

const StravaLogo = () => {
  return (
    <Link className={styles.brandingContent} to="/home">
      <img src={stravaImg} alt="strava" />
    </Link>
  );
};

export default StravaLogo;
